import React, {useState, useContext, useEffect} from 'react'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import SearchBar from './SearchBar'
import Topbar from './Topbar'
import InventoryForm from './InventoryForm'
import { Button, Row, Col } from 'react-bootstrap'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import UsersItems from './UsersItems'
import FormFields from './FormFields'
import moment from 'moment'
import './Home.css'
import { saveAs } from 'file-saver'
import ConfirmDialog from './ConfirmDialog'
import {BsExclamationCircle, BsInfoCircle, BsFillSignStopFill} from 'react-icons/bs'
import { FaCheckCircle } from "react-icons/fa";
import AutoLogout from './AutoLogout';
import { trackPromise } from 'react-promise-tracker'
import NoInventories from './NoInventories'
import AdminUtilitiesPanel from './AdminUtilitiesPanel'


function Home2() {
    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext);

    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST

    const defaultActiveKey = 'user'

    const [inventoryItem, setInventoryItem] = useState(null)
    const [inventoryItems, setInventoryItems] = useState([])
    const [scrollToId, setScrollToId] = useState(null)
    const itemFields = FormFields()


    const [activeKey, setActiveKey] = useState(defaultActiveKey);
    const [searchType, setSearchType] = useState('by_all')
    const [mode, setMode] = useState('user')
    const [searchCriteria, setSearchCriteria] = useState(null)

    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})

    const [noInventories, setNoInventories] = useState([])

    const [utilityMode, setUtilityMode] = useState(false)

    const [noinventoryAttestation,setNoinventoryAttestation] = useState(false)

    // use for mass certification
    const [selectedItems, setSelectedItems] = useState([]);

    // const pages = [
    //     {page: "user", title: "Inventory by User"},
    //     {page: "admin", title: "Admin Functions"},
    // ]

    const noInventoriesListColumns = [
        {
            name: "last_name",
            header: "Last Name",
            type: 'text',
        },
        {
            name: "first_name",
            header: "First Name",
            type: 'text',
        },
        {
            name: "employee_acct",
            header: "Employee Account",
            type: 'text',
        },
        {
            name: "updated_at",
            header: "Date",
            type: 'date',
        }
    ]

    const tabSelected = (key) => {
        // store active tab and reset inventories and search - only if tab changed
        // console.log("Tab selected", key)

        // don't allow switching tabs if there is an opn item
        if (!!inventoryItem) {
            setConfirmDialogParams({
                show: true,
                text: ["You cannot switch tabs while an inventory item is open.", 'Please close (save changes if necessary) the inventory item before switching tabs.'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Attention',
                title_class: 'alert-title-black',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })

        } else {
            if (activeKey !== key) {
                userCtx.setActiveTab(key)
                setActiveKey(key)
                setMode(key)
                setSearchCriteria({})
                setInventoryItems([])
                setSelectedItems([]);
                setSearchType('by_all')

                // if my items selected call getNoInventories
                if (key === defaultActiveKey) {
                    getNoInventories()
                }
            }
        }
    }

    const isDateValid = (dateStr) => {
        const date = new Date(dateStr);
        return !isNaN(date.getTime());
    };

    const getNoInventoryAttestationStatus = (no_inventory_id) => {

        const getStatus = async (id) => {
            const url = `${baseURL}inventory_attests/invntry/${id}`
            await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    // "Content-Type": "application/json",
                    // accept:"application/json",
                },
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("No Inventory Attestation", data)
                if (data !== null && !!data.id) {
                    setNoinventoryAttestation(true)
                } else {
                    // no inventory attestation is found - returns looks likw {detail: <message>}
                    setNoinventoryAttestation(false)
                }
            })
            .catch(e => {
                console.log("error gettong no-inventories attestation status", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }
        trackPromise(
            getStatus(no_inventory_id)
        )
    }



    const getNoInventories = () => {

        const getAllNoInventories = async () => {
            const url = `${baseURL}noinventories/noinventories_by_user/me`
            await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    // "Content-Type": "application/json",
                    // accept:"application/json",
                },
            })
            .then((response) => {
                return response.json()
            })
            .then(data => {
                // console.log("Return from no inventories", data)
                // check if the current user has no-inventories
                // if so set a checkbox for "I don't have any devices"
                setNoInventories(data)
                // if Attestion period is ON get attestation status for no inventories
                // console.log("No Inventory Data", data)
                if (dictCtx.dict_attestion_status === 'ON' && !!data[0]?.id) {
                    getNoInventoryAttestationStatus(data[0].id)
                }
            })
            .catch(e => {
                console.log("error gettong all no-inventories", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }
        trackPromise(
            getAllNoInventories()
        )
    }
    

    const getInventoryItem = async (id) => {
        const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventories/${id}` : `${process.env.REACT_APP_API_URL_PROD}inventories/${id}`
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("inventories", data)
            if (!!data) {
                setInventoryItem(data)
            } 
        })
        .catch(e => {
            console.log("error getting selected item", e)
            setConfirmDialogParams({
                show: true,
                text: ['Unexpected error happened while trying to get selected item', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        
        })
    }



    const getUserInventoryItems = async (criteria, item_id) => {
        if (!userCtx.isLoggedIn) {
            return
        }

        // console.log("getUserInventoryItems - criteria", criteria?.value)
        // console.log("getUserInventoryItems - mode", mode)

        setInventoryItems([])
        let url = ''
        switch(activeKey) {
            case 'user':
                url = `${baseURL}inventories/inventories_by_user/me`;
                break;
            case 'admin':
                switch(searchType) {
                    case 'all_items':
                    case 'by_non_blank_comments':
                    case 'by_not_attested':
                        url = `${baseURL}inventories/inventory/with_recert`;
                        break;
                    case 'by_name':
                        // search by user id
                        // criteria should have {searchTerm: 'user_id', value: <value>}
                        // console.log("Getting inventories by criteria", criteria)
                        if (!!criteria.value) {
                            url = `${baseURL}inventories/inventories/by_employee_acct/${criteria.value}`;
                        }
                        
                        break;
                    case 'by_lab':
                        // criteria should have {searchTerm: 'lab', value: <value>}
                        if (!!criteria.value) {
                            url = `${baseURL}inventories/search_inventories/by_lab/${encodeURIComponent(criteria.value)}`;
                        }
                        break;
                    case 'by_dev_type':
                        if (!!criteria.value) {
                            url = `${baseURL}inventories/search_inventories/by_device_type/${encodeURIComponent(criteria.value)}`;
                        }
                        break;
                    case 'by_cert_status':
                    case 'by_req_onsite_encr_ver':
                            // criteria should have {searchTerm: 'cert_status', value: <value>}
                            url = `${baseURL}inventories/inventory/with_recert`;
                            break;
                    case 'by_no_inventories':
                        url = `${baseURL}noinventories/?skip=0&limit=100000`;
                        break;
                    case 'by_mass_certification':
                        if (!!criteria.value) {
                            url = `${baseURL}inventories/search_inventories/by_device_type/${encodeURIComponent(criteria.value)}`;
                        }
                        break;
                    default:
                        url = ''
                }
                
                break;
            default:
                break;
        }

        if(url === '') {
            setInventoryItems([])
            return
        }

        const getRequestedItems = async (url) => {
            // console.log("Search Type", searchType)
            await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                }
            })
            .then((response) => response.json())
            .then(data => {
                
                if (!!data) {
                    // console.log("inventories", data)
                    // console.log("searchType", searchType)
                    // console.log("criteria", criteria)
                    if (searchType === 'by_no_inventories') {
                        if (data.count > 0) {
                            setNoInventories(data.data)
                        } else {
                            setNoInventories([])
                        }
                        
                    } else if (searchType === 'all_items' || searchType === 'by_cert_status') {
                        // filter by certification type
                        switch(criteria?.value) {
                            case 'Not Certified':
                                setInventoryItems(data
                                    .filter(item => item.initial_validation_by === null /*&& item.final_validation_by === null*/)
                                    // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                                )
                                setScrollToId(item_id)
                                break;
                            case 'With Certification':
                                setInventoryItems(data
                                    .filter(item => item.initial_validation_by !== null && item.final_validation_by === null)
                                    // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                                )
                                setScrollToId(item_id)
                                break;
                            // case 'With Final Certification':
                            //     setInventoryItems(data
                            //         .filter(item => item.initial_validation_by !== null && item.final_validation_by !== null)
                            //         // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                            //     )
                            //     setScrollToId(item_id)
                            //     break;
                            default:
                                if (activeKey === 'user') {
                                  // don't show to regular users records that are (lost/stolen or returned) and certified
                                  const filteredData = data.filter(d => dictCtx.dict_status_to_hide.find(ds => ds === d.device_status))
                                  console.log("filteredData", filteredData)
                                  setInventoryItems(data.filter(d => dictCtx.dict_status_to_hide.find(ds => ds === d.device_status)))
                                } else {
                                  setInventoryItems(data)
                                }
                                
                                setScrollToId(item_id)
                                // setInventoryItems(data.sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                        }
                    } else if ((searchType === 'by_lab' || searchType === 'by_dev_type' || searchType === 'by_mass_certification')) {
                        if (data.data?.length > 0) {
                            // setInventoryItems(data.data.sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                            // sort by name (last, then first), then by creation date then by devide id
                            // const withStatus = data.data
                            //   .filter(dev => !!dev.device_status)
                            //   .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id) ) 

                            // console.log("with status", withStatus)

                            // const withoutStatus = data.data
                            //   .filter(dev => !dev.device_status)
                            //   .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id) ) 
                            
                            // console.log("without status", withoutStatus)
                            // setInventoryItems([...withStatus, ...withoutStatus])

                            // if searchType === 'by_mass_certification' do extra filtering:
                            // we only want devices with device status "in use" and not certified
                            if (searchType === 'by_mass_certification') {
                                const filtered = data.data.filter(d => d.device_status === 'DEVICE IN USE' && d.initial_validation_date === null)
                                // console.log("filtered", filtered)
                                setInventoryItems(filtered
                                  .sort((a, b) => (a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id) ) )
                                )
                            }
                            else 
                            {
                            setInventoryItems(data.data
                                  .sort((a,b) => (a.device_status ? 'AAA' : 'ZZZ').localeCompare(b.device_status ? 'AAA' : 'ZZZ') || (a.initial_validation_date ? 'ZZZ' : 'AAA').localeCompare(b.initial_validation_date ? 'ZZZ' : 'AAA') || a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id) ) )
                            }

                            // setInventoryItems(data.data
                            //   .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id) ) )
                            
                            
                            // // try to scroll to the recent open item
                                // setScrollToId(item_id)
                            // do not auto-scroll
                            setScrollToId(null)
                        } else {
                            setInventoryItems([])
                            setScrollToId(null)
                        }
                        
                    } else if (searchType === 'by_req_onsite_encr_ver') {
                        // console.log("by req onsite validation", data.filter(item => !!item.request_onsite_encryption_validation))
                        setInventoryItems(data
                            .filter(item => !!item.request_onsite_encryption_validation)
                            //.sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at))
                            .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id))) 

                        setScrollToId(item_id)
                    } else if (searchType === 'by_non_blank_comments') {
                        setInventoryItems(data
                            .filter(item => !!item.comments === true)
                            // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                            .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id))) 
                        setScrollToId(item_id)
                    } else {
                        if (activeKey === 'user') {
                            // don't show to regular users records that are (lost/stolen or returned) and have been certified
                            // function filterUserDevices returns false if device is stolen or returned and then certified
                            const filterUserDevices = (dev) => {
                              if (dictCtx.dict_status_to_hide.findIndex(ds => ds === dev.device_status) < 0) {
                                return true; // not status to filter
                              }
                              if (dev.inventory_recerts?.length > 0) {
                                return (dev.inventory_recerts.findIndex(ir => ir.initial_validation_date !== null 
                                  && isDateValid(ir.initial_validation_date) // recert date is a valid date
                                  && new Date(ir.initial_validation_date) >= new Date(dictCtx.dict_certification_start_date)
                                ) < 0)
                              }
                              return true;
                            }
                            const filteredData = data.filter(dev => filterUserDevices(dev));
                              
                            // console.log("filteredData", filteredData)
                            setInventoryItems(filteredData
                              // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                              .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id))) 
                        } else {
                          setInventoryItems(data
                            // .sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                            .sort((a,b) => a.last_name.localeCompare(b.last_name) || a.first_name.localeCompare(b.first_name) || new Date(a.created_at) - new Date(b?.created_at) || a.id.localeCompare(b.id))) 
                        }
                        // console.log("setting up items as ", data.sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))
                        
                        setScrollToId(item_id)
                    }
                    
                }
                if (activeKey === 'user') {
                    getNoInventories()
                }
                
            })
            .catch(e => {
                console.log("error getting user's inventory items", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened while trying to get inventory items', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        } 
            
        trackPromise(
            getRequestedItems(url)
        )
        
    }






    const onSelect = (selectedValue) => {
        // console.log("Selected", selectedValue)
        if (!!selectedValue && !!selectedValue.id) {
            trackPromise(
                getInventoryItem(selectedValue.id)
            )
        } else {
            setInventoryItem(null)
        }
        
    }


    // user selected a search term (name, location, serial number, etc.)
    // searchTerm - selected value
    // searcType: "by_name" | "by_location" | "by_all" (name + serial number + ...)
    // get the list of inventories matching these criteria
    // const onSearchTermSelect = (searchTerm, searchType) => {
    //     console.log("Search critreria selected - value, type", searchTerm, searchType)


    // }





    const onItemSelect = (selectedItem) => {
        // console.log("Clicked on ", selectedItem.id)
        if (searchType === 'by_mass_certification') {
          // mass certification mode - toggle selection, don't open the item
          if (selectedItems.includes(selectedItem.id)) {
            // remove from selected items
            setSelectedItems(selectedItems.filter(i => i !== selectedItem.id));
          } else {
            // add selected
            setSelectedItems([...selectedItems, selectedItem.id]);
          }
        } else {
          if (!!selectedItem && !!selectedItem.id) {
              trackPromise(
                  getInventoryItem(selectedItem.id)
              )
          } 
        }
        
        
    }

    const closeInventoryItem = (refresh) => {
        // console.log("Home - onClose - refresh, mode, item id", refresh, mode, inventoryItem.id)
        const item_id = inventoryItem.id
        setInventoryItem(null)
        
        if (refresh) {
            getUserInventoryItems(searchCriteria, item_id)
        }
    }

    const addNewInventoryItem = () => {
        const newItem = {}
        itemFields.forEach(ff => newItem[ff.name] = ff.null_value ?? '' )
        if (activeKey === 'admin') {
            newItem['last_name'] = ''
            newItem['first_name'] = ''
            newItem['employee_acct'] = ''
        } else {
            newItem['last_name'] = userCtx.last_name
            newItem['first_name'] = userCtx.first_name
            newItem['employee_acct'] = userCtx.user
        }

        setInventoryItem(newItem)
        
    }



    const deleteInventoryItem = async () => {
        const id = inventoryItem.id
        const url = `${baseURL}inventories/${id}` 
        
            await fetch(url, {
                method: 'DELETE',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                }
            })
            .then((response) => {
                if (response.ok) {
                    setTimeout(setInventoryItem(null), 100)
                }
                return response.json()
            })
            .then(data => {
                
                if (!!data) {
                    // console.log("inventories", data.message)
                    // setInventoryItem(data)

                    // refresh the list
                    getUserInventoryItems(searchCriteria)
                }
            })
            .catch(e => {
                console.log("error deleting inventory item", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened while trying to delete the inventory item', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
    }

    const onDeleteInventoryItem = () => {
        trackPromise(deleteInventoryItem())
    }


    const downloadReport = () => {
        // console.log("Report - activeKey, inventoryItems", activeKey, inventoryItems)
        if (inventoryItems.length > 0) {
            let columns = itemFields
                .filter(field => !!field.report && ((activeKey !== 'admin' && field.admin_only === false) || activeKey === 'admin'))
                .map(field => field.display_name)
            let names = columns.map(col => itemFields.find(field => field.display_name === col).name) 
            const columnTypes = columns.map(col => itemFields.find(field => field.display_name === col).type) 
            const columnReportTypes = columns.map(col => itemFields.find(field => field.display_name === col).report_type || '') 
            // console.log("columnTypes", columnTypes)
            // console.log("columnReportTypes", columnReportTypes)
            // console.log("names", names)
            if (activeKey === 'admin') {
                columns = columns.concat('Created Date', 'Last Update Date'/*, 'Attestation Date'*/)
                names = names.concat('created_date', 'last_update_date'/*, 'attestation_date'*/)
            } else {
                columns = columns.concat('Last Update Date')
                names = names.concat('last_update_date')
            }
            // console.log("Report - columns", columns)
            // console.log("Report - names", names)
            const headerRow = columns.map(col => `"${col}"`).join(',')
            const rows = inventoryItems.map((item) => {
                return names.map((name,colIndex) => {
                    // console.log("Report generation - column name, type, value", name, columnTypes[colIndex], item[name])
                    if (columnTypes[colIndex] === 'datetime-local' || columnTypes[colIndex] === 'date') {
                        // format date
                        // return !!item[name] ? `"${moment.utc(item[name]).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"` : ''
                        return !!item[name] ? `"${moment.utc(item[name]).startOf('minute').format('YYYY-MM-DD hh:mm a')}"` : ''
                    }
                    if (columnTypes[colIndex] === 'text' || columnTypes[colIndex] === 'textarea' || columnTypes[colIndex] === 'number' || columnTypes[colIndex] === 'dictionary') {
                        return !!item[name] ? `"${item[name].replace(/"/g, '""')}"` : ''
                    }
                    if (columnTypes[colIndex] === 'checkbox' ) {
                        return !!item[name] ? `"Yes"` : `"No"`
                    }
                    // special case for images
                    if (columnTypes[colIndex] === 'array' && columnReportTypes[colIndex] === 'array_count') {
                        // format date
                        // return `"${moment.utc(item[name]).startOf('minute').format('YYYY-MM-DDTHH:mm')}"`
                        return item[name]?.length
                    }
                    // additional columns with dates depend on the mode
                    if (!!columnTypes[colIndex] === false) {
                        // additional date columns of the report
                        switch(name) {
                            case 'last_update_date':
                                // for user mode use the latest of created, updated, attested dates; for admins use last updated date
                                if (activeKey === 'admin') {
                                    // return `"${moment.utc(item['updated_at']).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                                    return `"${moment.utc(item['updated_at']).startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                                } else {
                                    // user mode
                                    let dates = [item['created_at'], item['updated_at']];
                                    if (!!item.inventory_attests && item.inventory_attests.length > 0) {
                                        item.inventory_attests.forEach(att => {
                                            if (!!att['created_at']) {
                                                dates.push(att['created_at']) 
                                            }
                                            if (!!att['updated_at']) {
                                                dates.push(att['updated_at'])
                                            }
                                        })
                                    }
                                    const latest_date = dates.sort((a,b) => new Date(b) - new Date(a))[0]
                                    // return `"${moment.utc(latest_date).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                                    return `"${moment.utc(latest_date).startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                                }
                            break;

                            case 'created_date':
                                // return `"${moment.utc(item['created_at']).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                                return `"${moment.utc(item['created_at']).startOf('minute').format('YYYY-MM-DD hh:mm a')}"`
                            break;

                            case 'attestation_date':
                                let dates = []
                                if (!!item.inventory_attests && item.inventory_attests.length > 0) {
                                    item.inventory_attests.forEach(att => {
                                        if (!!att['created_at']) {
                                            dates.push(att['created_at']) 
                                        }
                                        if (!!att['updated_at']) {
                                            dates.push(att['updated_at'])
                                        }
                                    })
                                    const latest_date = dates.sort((a,b) => new Date(b) - new Date(a))[0]
                                    // return `"${moment.utc(latest_date).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"`  
                                    return `"${moment.utc(latest_date).startOf('minute').format('YYYY-MM-DD hh:mm a')}"`  
                                } else {
                                    return null
                                }
                                 
                            break;
                        }
                    }
                    return null
                }).join(',')
                
            })

            // console.log("Columns", columns)
            // rows.forEach(r => console.log(r))
            // const lines = [columns.join(',')].concat(rows).join('\n')
            const lines = [headerRow].concat(rows).join('\n')
            const blob = new Blob([lines], { type: 'text/csv' });
            // console.log("searchCriteria", searchCriteria)
            // console.log("searchType", searchType)
            // const file_name = `InventoryItems_${searchCriteria.searchTerm}_${searchCriteria.label?.replace(' ','-')}_${moment.utc(new Date()).startOf('second').format('YYYY-MM-DD HH_mm_ss')}.csv`
            let report_name = ''
            let file_name = ''
            if (activeKey === 'admin') {
                if (searchType === 'by_cert_status' && Object.keys(searchCriteria).length === 0) {
                    report_name = 'by_cert_status_All Certification Statuses'
                } else {
                    report_name = `${searchType}_${searchCriteria?.label}`
                }
                file_name = `InventoryItems_${report_name}_${moment.utc(new Date()).local().startOf('second').format('YYYY-MM-DD HH_mm_ss')}.csv`
            } else {
                // user report
                file_name = `MyInventoryItems_${moment.utc(new Date()).local().startOf('second').format('YYYY-MM-DD HH_mm_ss')}.csv`
            }
            

            setTimeout(() => {
                saveAs(blob, file_name)
            }, 300)

            
        } else if (noInventories.length > 0) {
            const names = noInventoriesListColumns.map(col => col.name) 
            const columnTypes = noInventoriesListColumns.map(col => col.type) 
            const columns = noInventoriesListColumns.map(col => `"${col.header}"`)
            const rows = noInventories.map((item) => {
                return names.map((name,colIndex) => {
                    if (columnTypes[colIndex] === 'datetime-local' || columnTypes[colIndex] === 'date') {
                        // format date
                        return !!item[name] ? `"${moment.utc(item[name]).local().startOf('minute').format('YYYY-MM-DD hh:mm a')}"` : ''
                    }
                    if (columnTypes[colIndex] === 'text' || columnTypes[colIndex] === 'number' || columnTypes[colIndex] === 'dictionary') {
                        return !!item[name] ? `"${item[name]}"` : ''
                    }
                    if (columnTypes[colIndex] === 'checkbox' ) {
                        return !!item[name] ? 'Yes' : 'No'
                    }
                    // special case for images
                    if (columnTypes[colIndex] === 'array') {
                        // format date
                        // return `"${moment.utc(item[name]).startOf('minute').format('YYYY-MM-DDTHH:mm')}"`
                        return item[name]?.length
                    }
                }).join(',')
                
            })

            const lines = [columns.join(',')].concat(rows).join('\n')
            const blob = new Blob([lines], { type: 'text/csv' });
            const file_name = `Attested_to_NoInventoryItems_${moment.utc(new Date()).local().startOf('second').format('YYYY-MM-DD HH_mm_ss')}.csv`

            setTimeout(() => {
                saveAs(blob, file_name)
            }, 300)
        }
    }




    const onCertifyNoDevices = () => {

        const createNoInventories = async () => {
            const url = `${baseURL}noinventories/`
            await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    "Content-Type": "application/json",
                    accept:"application/json",
                },
                body: JSON.stringify({
                    last_name: userCtx.last_name,
                    first_name: userCtx.first_name,
                    employee_acct: userCtx.user,
                })
            })
            .then((response) => {
                if (response.ok) {

                }
                return response.json()
            })
            .then(data => {
                // console.log("Return from no inventories", data)
                getNoInventories()
            })
            .catch(e => {
                console.log("error deleting inventory item", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened while trying to delete the inventory item', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }
        trackPromise(
            createNoInventories()
        )
        
        
    }



    const deleteNoInventory = () => {

        // console.log("let's delete no inventory records")
        // console.log("noInventories", noInventories)
        const deleteNoInventoryRecordById = async (id) => {
            const url = `${baseURL}noinventories/${id}`
            await fetch(url, {
                method: 'DELETE',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    "Content-Type": "application/json",
                    accept:"application/json",
                }
            })
            .then((response) => {
                if (response.ok) {

                }
                return response.json()
            })
            .then(data => {
                // console.log("Return from no inventories delete", data.message)
            })
            .catch(e => {
                console.log("error deleting inventory item", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }

        noInventories.forEach((noinv => {
            // console.log("deleteing no inventory record with id", noinv.id)
            deleteNoInventoryRecordById(noinv.id)
        }))
    }

    const onLogout = () => {
        setInventoryItem(null)
        setInventoryItems([])
        setSearchCriteria(null)
        setSearchType('by_all')
    }




    // const onAttestModeClick = () => {
    //     // console.log("Home - setting mode to user_attestation")

    //     // setMode('user_attestation')
    // }



    const onUtilitiesClick = () => {
        setUtilityMode(true)

    }


    const attestationModeChange = (attestationValue) => {
        console.log("Attestation mode changed attestationValue", attestationValue)
        // get updated attestation mode
        const refreshAttestationDict = async () => {
            const dict_id = dictCtx.dictionaries.filter(de => de.system_name === "ATTESTATION_STATUS")[0].id
            const url = `${baseURL}dict_system_dictionaries/${dict_id}`
            await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    // "Content-Type": "application/json",
                    // accept:"application/json",
                }
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("Return from attestation dict", data)
                if (data !== null && !!data.dictionary_value) {
                    const attestation_mode = data.dictionary_value
                    dictCtx.set_attestation_status(attestation_mode)
                }
            })
            .catch(e => {
                console.log("error deleting inventory item", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })


        }
        trackPromise(
            refreshAttestationDict()
        )
    }


    const onAttestNoInventory = () => {

        const sendAttestation = async () => {
            const url = `${baseURL}inventory_attests/`;
            const body = {
                added_by_userid: userCtx.id,
                inventory_id: null,
                noinventory_id: noInventories[0].id,
                record_added_year: '' + new Date().getFullYear(),
                // comments: "string"
            }
            await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then((response) => {
                // console.log("sendAttestation response", response.status)
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    // not attested item
                    console.log("No attestation found")
                    // setAttestationStatus({text: 'Please attest that the device information is accurate', style: 'item-not-attested', button: 'Attest', disabled: false})
                    return null
                }
            })
            .then(data => {
                if (data !== null) {
                    // console.log("Return from sendAttestation", data)
                    // setAttestationStatus({...data, text: 'Attested', style: 'item-attested', button: 'Attest', disabled: true})
                    if (!!data && !!data.id) {
                        setNoinventoryAttestation(true)
                    } else {
                        setNoinventoryAttestation(false)
                    }
                    
                }

            })
            .catch(e => {
                console.log("error getting attestion", e)
                setNoinventoryAttestation(false)
                // setConfirmDialogParams({
                //     show: true,
                //     text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                //     textClass: 'confirmation-text',
                //     // prompt_class: styles['alert-prompt-black'],
                //     cancel_button_text: null,
                //     confirm_button_text: 'OK',
                //     confirm_button_variant: 'primary',
                //     onClose: (result) => setConfirmDialogParams({show:false}),
                //     title: 'Error',
                //     title_class: 'alert-title',
                //     icon: <BsExclamationCircle />
                // })
            })
        }

        trackPromise(
            sendAttestation()
        )
    }


    const selectAllDevices = () => {
        setSelectedItems(inventoryItems.map(i => i.id));
    }

    const unselectAllDevices = () => {
        setSelectedItems([]);
    }


    const onMassCertifyClick = () => {
        setConfirmDialogParams({
            show: true,
            text: [
              `You are about to certify ${selectedItems.length} device${selectedItems.length > 1 ? 's':''}.`,
              "This operation is not reversible.",
              "Do you want to proceed?"
            ],
            textClass: 'confirmation-text',
            prompt_class: 'alert-prompt-black',
            cancel_button_text: 'No',
            confirm_button_text: 'Yes',
            confirm_button_variant: 'danger',
            onClose: (result) => {
                if (result === 'confirm') {
                    massCertifySelected();
                }
                setConfirmDialogParams({show:false})
            },
            title: 'Please Confirm',
            title_class: 'alert-title',
            icon: <BsFillSignStopFill />,
            confirm_only: false,
        })
    }



    const massCertifySelected = () => {
        // console.log("userCtx.user, userCtx.id", userCtx.user, userCtx.id)
        // console.log("date", new Date().toUTCString())

        const massCertify = async () => {
            const url = `${baseURL}inventory_recerts/multi`
            const body = JSON.stringify({
              inventory_ids: selectedItems,
              added_by_userid:userCtx.user,
              initial_validation_by:userCtx.user,
              initial_validation_date:new Date().toISOString(),
            });
            await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: body,
            })
            .then((response) => response.json())
            .then(data => {
                if (data?.count > 0) {
                    getUserInventoryItems(searchCriteria);
                    setConfirmDialogParams({
                      show: true,
                      text: [`${data.count} device${data.count > 1 ? 's':''} certified`],
                      textClass: 'confirmation-text',
                      // prompt_class: styles['alert-prompt-black'],
                      cancel_button_text: null,
                      confirm_button_text: 'OK',
                      confirm_button_variant: 'primary',
                      onClose: (result) => setConfirmDialogParams({show:false}),
                      title: 'Info',
                      title_class: 'alert-title-black',
                      icon: <BsInfoCircle />,
                      confirm_only: true,
                  })
                }
            })
            .catch(e => {
                console.log("error mass certifying devices", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }

        trackPromise(
            massCertify()
        )
    }


    useEffect(() => {
        // restore session after refersh
        if (!!!userCtx.isLoggedIn && !!sessionStorage.getItem("user")) {
            const uInfo = JSON.parse(sessionStorage.getItem("user"));
            // console.log("Home uInfo", uInfo, "activeTab", userCtx.activeTab)
            userCtx.setUserInfo(uInfo);
            setActiveKey(uInfo.activeTab)
            setMode(uInfo.activeTab)

            // console.log("Home - setting mode to ", uInfo.activeTab)

            // if (uInfo.activeTab === defaultActiveKey) {
            //     setMode("user")
            // } else {
            //     setMode("admin")
            // }
            // setMode(uInfo.activeTab)
        } else {
            if (!userCtx.isLoggedIn) {
                // console.log("Home - setting mode to ", defaultActiveKey)
                setActiveKey(defaultActiveKey)
                setMode(defaultActiveKey)
            }
            
        }
    })


    useEffect(() => {
        let isMounted = true
        if (!!userCtx.isLoggedIn && dictCtx.dictionaries === null) {
            
            // get dictionaries
            const getDictionaries = async () => {
                const url = `${baseURL}dict_system_dictionaries/`;
                const skip = 0
                const limit=1000

                await fetch(`${url}?skip=${skip}&limit=${limit}`, {
                        method: 'GET',
                        headers: {
                            Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                        }
                })
                .then((response) => response.json())
                .then(data => {
                    // console.log("dictionaries", data.data)
                    if (!!data.data) {
                        if(isMounted) {
                            dictCtx.setAllDictionaries(data.data)
                        }
                    }
                })
                .catch(e => {
                    console.log("error getting dictionaries", e)
                    setConfirmDialogParams({
                        show: true,
                        text: ['Unexpected error happened while trying to get dictionaries', 'Please try again', 'If the error persists please contact Support'],
                        textClass: 'confirmation-text',
                        // prompt_class: styles['alert-prompt-black'],
                        cancel_button_text: null,
                        confirm_button_text: 'OK',
                        confirm_button_variant: 'primary',
                        onClose: (result) => setConfirmDialogParams({show:false}),
                        title: 'Error',
                        title_class: 'alert-title',
                        icon: <BsExclamationCircle />,
                        confirm_only: true,
                    })
                })
            }
            trackPromise(
                getDictionaries()
            )
            // getUserInventoryItems(searchCriteria)
        } else if (!!userCtx.isLoggedIn && dictCtx.dictionaries !== null) {
            // getUserInventoryItems(searchCriteria)
        }

        return () => {
            isMounted = false
        }
    },[userCtx.isLoggedIn])  


    useEffect(() => {
        if (!!userCtx.isLoggedIn && dictCtx.dictionaries !== null) {
            getUserInventoryItems(searchCriteria)
        }
    }, [userCtx.isLoggedIn, dictCtx.dictionaries])


    useEffect(() => {
        getUserInventoryItems(searchCriteria)
    }, [searchCriteria, searchType, mode])

    return (
        <>
            <Topbar onLogout={onLogout} editMode={!!inventoryItem} />
            {userCtx.isLoggedIn &&
            <>
                <Tabs justify activeKey={activeKey} onSelect={tabSelected} className="mb-3" variant='tabs'>
                    
                    {userCtx.is_super_user &&
                    
                    <Tab eventKey={'admin'} title={'Admin Functions'} key={'admin'} /*disabled={!!inventoryItem}*/>
                        {!!! inventoryItem  && !utilityMode &&
                        <>
                            <SearchBar 
                                onSelect={onSelect} 
                                clear={!!!inventoryItems} 
                                searchType={searchType} 
                                onSearchTypeChange={(search_type) => {
                                  setSelectedItems([]);
                                  setSearchType(search_type);
                                }}
                                setSearchCriteria={setSearchCriteria}
                                searchCriteria={searchCriteria}
                                />

                            {searchType !== 'by_mass_certification' ?
                            
                            <Row className='my-3' >
                                <div className='col  d-flex justify-content-start align-items-start'>
                                    <div className='ps-5'>
                                        <Button size='sm' variant="outline-primary" className='font08' onClick={onUtilitiesClick}>
                                            Admin Utilities
                                        </Button>

                                    </div>
                                </div>


                                <div className='col mx-5 d-flex justify-content-end align-items-start'>
                                    <Button size='sm' variant="outline-primary" 
                                        className='mx-2 font08' 
                                        onClick={addNewInventoryItem} 
                                        disabled={!!inventoryItem}
                                    >
                                        <span className='mx-2'>Add Device</span>
                                    </Button>
                                    
                                    <Button size='sm' variant="outline-primary" 
                                        className='mx-2 font08' 
                                        disabled={inventoryItems?.length === 0 && noInventories.length === 0} 
                                        onClick={downloadReport} >
                                            <span className='mx-2'>Download Report</span>
                                    </Button>
                                </div>
                            </Row>
                            :
                            <>
                            {inventoryItems?.length > 0 &&
                            <>
                            <Row className='my-3'>
                              <div className='col  d-flex justify-content-start align-items-start'>
                                <div className='ps-5 text-primary'>
                                  Select items to certify: click on item(s) to toggle selection or use Sellect All/Unselect All buttons
                                </div>
                              </div>
                            </Row>
                            <Row className='my-3'>
                              <div className='col mx-5 d-flex justify-content-start align-items-start'>
                                  <Button size='sm' variant="outline-primary" 
                                      className='mx-2 font08' 
                                      onClick={selectAllDevices} 
                                  >
                                      <span className='mx-2'>Select All</span>
                                  </Button>
                                    
                                  <Button size='sm' variant="outline-primary" 
                                      className='mx-2 font08' 
                                      onClick={unselectAllDevices} >
                                          <span className='mx-2'>Unselect All</span>
                                  </Button>
                                  <Button size='sm' variant="outline-primary" 
                                      className='mx-2 font08' 
                                      disabled={selectedItems.length === 0}
                                      onClick={onMassCertifyClick} >
                                          <span className='mx-2'>Mass Certify Selected Devices</span>
                                  </Button>
                                </div>
                            </Row>
                            </>
                            }
                            </>
                            }
                        </>
                        }


                        {utilityMode && 
                            <AdminUtilitiesPanel 
                                show={utilityMode} 
                                closeUtilityPanel={() => setUtilityMode(false)} 
                                onAttestationModeChange={attestationModeChange}
                                refreshUserItems={() => getUserInventoryItems(searchCriteria)}
                            />
                        }
                        

                    </Tab>
                    }

                    <Tab eventKey={'user'} title={'My Devices'} key={'user'} /*disabled={!!inventoryItem}*/>
                        {!!!inventoryItem &&
                            <Row className='my-3' >
                                <div className='col  mx-5 d-flex justify-content-end align-items-start'>
                                    <div className='ps-5'>
                                        {/* {noInventories.find(noinv => noinv.first_name.toUpperCase() === userCtx.first_name.toUpperCase() && 
                                                noinv.last_name.toUpperCase() === userCtx.last_name.toUpperCase() 
                                                && noinv.employee_acct.toUpperCase() === userCtx.user.toUpperCase()) !== undefined ? */}

                                        

                                        <div className='col mx-5 d-flex justify-content-end align-items-start'>
                                            {noInventories.length > 0 ?
                                                <Button size='sm' variant="outline-primary" className='mx-2 mt-3 font08' disabled>
                                                    <FaCheckCircle size='1.5em' color='green'/>
                                                    &nbsp; &nbsp; I don't have any portable devices
                                                </Button>
                                                
                                                :
                                                <Button size='sm' variant="outline-primary" className='mx-2 mt-3 font08' 
                                                    onClick={onCertifyNoDevices}
                                                    disabled={inventoryItems?.length > 0}
                                                >
                                                    <span className='mx-2'>I don't have any portable devices</span>
                                                </Button>
                                            }

                                            <Button size='sm' variant="outline-primary" 
                                                className='mx-2 mt-3 font08' 
                                                onClick={addNewInventoryItem}
                                                disabled={!!inventoryItem}
                                            >
                                                    <span className='mx-2'>Add Device</span>
                                            </Button>

                                            <Button size='sm' variant="outline-primary" 
                                                className='mx-2 mt-3 font08' 
                                                disabled={inventoryItems?.length === 0 && noInventories.length === 0} 
                                                onClick={downloadReport} >
                                                    <span className='mx-2'>Download Report</span>
                                            </Button>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </Row>
                        }
                        {!!!inventoryItem && inventoryItems?.length === 0  &&
                        <Row>
                            <Col xs={{ span: 10, offset: 1 }} className='text-center'>
                                {noInventories.length > 0 ?
                                <>
                                    <p className='fs-2'>
                                        You have confirmed that you don't have any portable devices.
                                    </p>
                                    <p className='fs-4'>
                                        If this is incorrect please use <span className='text-primary fw-bold'>Add Device</span> button to create a device record for each portable device you have. 
                                    </p>
                                </>
                                :
                                <>
                                    <p className='fs-4'>
                                    Please use <span className='text-primary fw-bold'>Add Device</span> button to create a device record for each portable device you have. 
                                    </p>
                                    <p className='fs-4'>
                                    If you don't have any portable devices please confirm it using <span className='text-primary fw-bold'>I don't have any portable devices</span> button.
                                    </p>
                                </>
                                }
                            </Col>
                        </Row>
                        }

                        {!!!inventoryItem && inventoryItems?.length === 0  && dictCtx.dict_attestion_status === 'ON' &&
                        <Row>
                            <Col xs={{ span: 10, offset: 1 }} className='text-center'>
                                {noInventories.length > 0 && noinventoryAttestation === false &&
                                <>
                                    <Button size='lg' variant="danger" 
                                        className='mx-2 font08' 
                                        onClick={onAttestNoInventory} 
                                    >
                                        Please attest that you don't have any portable devices.
                                    </Button>
                                </>
                                }
                            </Col>
                        </Row>
                        }
                    </Tab>
                </Tabs>


                {!!inventoryItem && dictCtx.allDictionaries !== null ? 
                    <InventoryForm 
                        // mode={activeKey} 
                        mode={mode} 
                        item={inventoryItem} 
                        onClose={(refresh) => closeInventoryItem(refresh)} 
                        onDelete={onDeleteInventoryItem}
                        deleteNoInventory={deleteNoInventory}
                        
                    />
                :
                <>
                    {!!!inventoryItem && inventoryItems?.length > 0  && !utilityMode &&
                        // <UsersItems mode={activeKey} onItemSelect={onItemSelect}  addNewInventoryItem={addNewInventoryItem} inventoryItems={inventoryItems} />
                        <UsersItems selectedItems={selectedItems} scrollToId={scrollToId} mode={mode} onItemSelect={onItemSelect}  addNewInventoryItem={addNewInventoryItem} inventoryItems={inventoryItems} scrollToId={scrollToId}/>
                    }
                </>
                }

                {activeKey === 'admin' && !!!inventoryItem && searchType === 'by_no_inventories' &&
                    <NoInventories noInventories={noInventories} columns={noInventoriesListColumns} />
                }

            </>
            }

{confirmDialogParams.show &&
            <ConfirmDialog 
                show={confirmDialogParams.show}
                iconColor='red'
                iconSize='2rem'
                icon={confirmDialogParams.icon}
                title={confirmDialogParams.title}
                title_class={confirmDialogParams.title_class}
                text={confirmDialogParams.text}
                textClass={confirmDialogParams.textClass}
                prompt_class={confirmDialogParams?.prompt_class}
                cancel_button_text={confirmDialogParams.cancel_button_text}
                confirm_button_text={confirmDialogParams.confirm_button_text}
                confirm_button_variant={confirmDialogParams.confirm_button_variant}
                onClose={confirmDialogParams.onClose}
                confirm_only={confirmDialogParams.confirm_only}
            />
}

            <AutoLogout onLogout={onLogout}/>
            {/* <LoadingSpinner size='100px' /> */}
        </>
    )
}

export default Home2
